import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLoaderData } from "react-router";
import { ITeamSchedule } from "../../types/api";

import "../../assets/css/wibb/pages/tournaments.scss";
import { getTeamSchedule } from "../../lib/api";
import Schedule from "../../components/Schedule";

export const loader = async ({ params }: any) => {
    const { teamId, tournamentId } = params;

    const [{ schedule }] = await Promise.all([getTeamSchedule(teamId)]);
    const { teamName } = schedule;
    const header = `${teamName} Schedule`;

    return {
        tournamentId,
        schedule,
        header,
    };
};

const TournamentTeam = (): React.JSX.Element => {
    const { schedule } = useLoaderData() as {
        schedule: ITeamSchedule;
    };

    return (
        <div data-testid="teamScheduleContent">
            <Container>
                <Row>
                    <Col>
                        <Schedule
                            schedule={schedule.games.filter(
                                g => !["Deleted"].includes(g.status),
                            )}
                            scheduleType="team"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default TournamentTeam;
